import { Autocomplete, SxProps, TextField, Theme } from "@mui/material";
import { useContext } from "react";

import { LayoutsConfig, MainContext } from "../../../main/context/MainContextProvider";

export type SelectedClientMenuProps = {
  textFieldSx?: SxProps<Theme>
};

export default function SelectClientDashboardMenu(props: SelectedClientMenuProps) {
  const { textFieldSx } = props;
  const { selectedDashboardClient, setSelectedDashboardClient, userClients } =
    useContext(MainContext);
  const { isMobile, layout } = useContext(MainContext);

  const clientsIds = userClients?.map((client) => client.id);

  return (
    <Autocomplete
      size="small"
      className="px-2"
      value={selectedDashboardClient?.id || ""}
      onChange={(_: any, newValue: string | null | undefined) => {
        if (!newValue) {
          setSelectedDashboardClient(undefined);
          return;
        }
        setSelectedDashboardClient(userClients?.find((client) => client.id === newValue));
      }}
      id="plant-select"
      clearOnEscape
      options={clientsIds ?? []}
      getOptionLabel={(option) => {
        return userClients?.find((client) => client.id === option)?.name || "";
      }}
      sx={{ width: isMobile ? "100%" : 200 }}
      renderInput={(params) => <TextField
        sx={{
          '& .MuiInputBase-input': {
            color: layout == LayoutsConfig.LayoutTwo ? "#FFF" : undefined
          },
          '& .MuiInputLabel-root': {
            color: layout == LayoutsConfig.LayoutTwo ? "#8F969E" : undefined
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: layout == LayoutsConfig.LayoutTwo ? '#E9E9E9' : undefined,
          },
          ...textFieldSx
        }}
        {...params} label="Cliente" />}
    />
  );
}
